import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const USERS = [
  { email: 'info@taurisjapan-ai.com',       password: 'Tauris', role: 'admin' },
  { email: 'mitotakashi@taurisjapan-ai.com', password: 'Tauris', role: 'user'  },
];

const Login = () => {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setError('');

    if (!email.trim() || !password) {
      setError('Please enter both email and password.');
      return;
    }

    setLoading(true);

    // Simulate brief auth delay
    setTimeout(() => {
      const matched = USERS.find(u => u.email === email.trim().toLowerCase() && u.password === password);
      if (matched) {
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('loginEmail', matched.email);
        localStorage.setItem('loginRole', matched.role);
        localStorage.setItem('loginTime', Date.now().toString());
        navigate('/');
      } else {
        setError('Invalid email or password.');
      }
      setLoading(false);
    }, 400);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <img src="/sentradesk_logo.png" alt="Sentradesk" className="login-logo"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
          <p className="login-subtitle">AI Interpretation Platform</p>
        </div>

        <form className="login-form" onSubmit={handleLogin}>
          {error && <div className="login-error">{error}</div>}

          <div className="login-field">
            <label className="login-label">Email</label>
            <input
              className="login-input"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              autoFocus
            />
          </div>

          <div className="login-field">
            <label className="login-label">Password</label>
            <input
              className="login-input"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </div>

          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className="login-footer">Powered by <a href="https://tauris.jp/" target="_blank" rel="noopener noreferrer" style={{color:'#26C6DA',textDecoration:'none'}}>Tauris Japan</a></p>
      </div>
    </div>
  );
};

export default Login;
